import React, {useState} from "react";
import {isDesktop} from "react-device-detect";
import csvDownload from "json-to-csv-export";
import {IconButton} from "@mui/material";
import {
    Delete as DeleteIcon,
    Edit as EditIcon,
    Email as EmailIcon,
    Download as DownloadIcon,
} from "@mui/icons-material";
import {useFiltered} from "@atttomyx/shared-hooks";
import {
    Cards,
    ConfirmDeleteDialog,
    FiltersAccordion,
    FloatingAddButton,
    FloatingButton
} from "@atttomyx/react-components";
import {NodeCard} from "../cards";
import {Actions} from "../node";
import {NodeFilters} from "../filters";
import {nodeService} from "../../services";
import {datetime, sorting, users} from "@atttomyx/shared-utils";
import {
    CSV_DELIMITER,
    CSV_FIELD_CREATED,
    CSV_FIELD_EMAIL,
    CSV_FIELD_FIRST_NAME,
    CSV_FIELD_LAST_NAME,
    CSV_FIELD_PHONE,
    CSV_FIELD_UPDATED,
    CSV_FILENAME_NODES,
    CSV_HEADERS_NODES
} from "../../constants";
import "./nodesPage.css";
import {BulkEmailDialog} from "../dialogs";

const NodesPage = (props) => {
    const { dimensions, snackbar, user, unique, households, nodes, filters,
        onDelete, onGotoAdd, onGotoEdit } = props;
    const [ showFilters, setShowFilters ] = useState(false);
    const [ showBulkEmail, setShowBulkEmail ] = useState(false);
    const [ deleting, setDeleting ] = useState(null);
    const filtered = useFiltered(nodes, filters, sorting.sortByLastNameAndFirstName);

    const downloadCsv = () => {
        const lines = [];

        filtered.forEach(node => {
            lines.push({
                [CSV_FIELD_FIRST_NAME]: node.firstName,
                [CSV_FIELD_LAST_NAME]: node.lastName,
                [CSV_FIELD_EMAIL]: node.emails && node.emails.length > 0 ? node.emails[0].value : "",
                [CSV_FIELD_PHONE]: node.phones && node.phones.length > 0 ? node.phones[0].value : "",
                [CSV_FIELD_CREATED]: datetime.getPrettyDateAndTime(node.created),
                [CSV_FIELD_UPDATED]: datetime.getPrettyDateAndTime(node.updated),
            });
        });

        csvDownload({
            data: lines,
            delimiter: CSV_DELIMITER,
            headers: CSV_HEADERS_NODES,
            filename: CSV_FILENAME_NODES,
        });
    };

    return <div className="nodes-page">
        <div className="filters">
            <FiltersAccordion
                filters={filters}
                form={NodeFilters}
                formProps={{
                    unique: unique,
                }}
                open={showFilters}
                onOpen={() => setShowFilters(true)}
                onClose={() => setShowFilters(false)}
            />
        </div>
        <Cards
            items={filtered}
            paging={filters.paging}
            dimensions={dimensions}
            renderer={(node) => node.id === deleting ? null :
                <NodeCard key={node.id} node={node} filters={filters}>
                    <IconButton
                        color="secondary"
                        title="Delete"
                        className="delete"
                        onClick={() => setDeleting(node)}
                    >
                        <DeleteIcon/>
                    </IconButton>
                    <Actions
                        node={node}
                    />
                    <IconButton
                        color="primary"
                        title="Edit"
                        onClick={() => onGotoEdit(node.id)}
                    >
                        <EditIcon/>
                    </IconButton>
                </NodeCard>}
        />
        <div className="floating-buttons-container">
            <FloatingButton
                className="floating-download"
                icon={<DownloadIcon/>}
                title="Download CSV"
                position={!dimensions.landscape || !dimensions.short ? "higher" : undefined}
                center={!dimensions.short}
                onClick={downloadCsv}
                disabled={!isDesktop}
            />
            <FloatingButton
                className="floating-email"
                icon={<EmailIcon/>}
                title="Bulk email"
                position={!dimensions.landscape || !dimensions.short ? "higher" : undefined}
                center={!dimensions.short}
                onClick={() => setShowBulkEmail(true)}
                disabled={filtered.length < 2}
            />
            <FloatingAddButton
                title="Add member"
                position={!dimensions.landscape || !dimensions.short ? "higher" : undefined}
                center={!dimensions.short}
                onClick={onGotoAdd}
            />
        </div>
        {showBulkEmail ?
            <BulkEmailDialog
                user={user}
                unique={unique}
                nodes={filtered}
                onCancel={() => setShowBulkEmail(false)}
            /> : null}
        {deleting ?
            <ConfirmDeleteDialog
                snackbar={snackbar}
                title={users.getFullName(deleting)}
                onCancel={() => setDeleting(null)}
                onDelete={(nodeId) => {
                    setDeleting(null);
                    onDelete(nodeId);
                }}
                deleter={(success, failure) => nodeService.deleteNode(deleting.id, success, failure)}
            /> : null}
    </div>
};

export default NodesPage;
